import ErrorIcon from '../../assets/icons/error.svg?react';

const DeleteConfirmation = ({ setDeleteModalOpen, itemToDelete, deleteHistory }) => {
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm pointer-events-auto"></div>

      {/* Popup Modal */}
      <div className="relative z-50  w-[400px] bg-core-black-contrast border rounded border-core-black-150 p-4">
        <div className="flex flex-col gap-6 items-center p-10 text-center">
          <h3 className="text-[22px]">Confirm deletion</h3>
          <ErrorIcon className="text-status-red " />
          <p>
            Are you sure you want to delete{' '}
            <span className="font-medium text-minima-orange-2023">{itemToDelete.FILE_NAME}</span>?
          </p>
          <p className="mt-2 text-gray-400 text-sm">
            This action cannot be undone. This will permanently delete the file and remove all
            associated records.
          </p>
          <div className="flex gap-2 justify-center w-full">
            <button
              onClick={() => {
                setDeleteModalOpen(false);
              }}
              className="btn-primary w-1/2 bg-core-black-contrast-2 hover:bg-slate-grey"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                deleteHistory(itemToDelete);
              }}
              className="btn-primary w-1/2 bg-status-red hover:bg-[red]"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DeleteConfirmation;
